// import { getFoPools } from '../../DataQuery';
// import { Query, abortFBMatch, apiErrorCallback } from '../../../../Common/graphqlFetch'

// export const updatePoolInfo = (match, pool, message, option) => {
//     let betType = message.bTyp,
//         poolStatus = message.st,
//         inplay = message.dtl?.betOffer?.inplay,
//         lines =  message.lines?.line,
//         instNo = message.instNo;
//     if(instNo>0){
//         betType = betType+instNo
//     }
//     const isUntag =option?.isUntag
//     if(isUntag){
//         match.poolInfo.normalPools = match.poolInfo.normalPools.filter(x => x != betType);
//         match.poolInfo.inplayPools = match.poolInfo.inplayPools.filter(x => x != betType);
//         match.poolInfo.sellingPools = match.poolInfo.sellingPools.filter(x => x != betType);
//         match.poolInfo.definedPools = match.poolInfo.definedPools.filter(x => x != betType);
//         return
//     }
//     switch (poolStatus) {
//         case 'Suspended':
//         case 'PayoutStarted':
//         case 'PayoutStopped':
//         case 'PayoutHold':
//         case 'Refund':
//         case 'RefundBeforeSuspend':
//             // for multi instance pools checking
//                 match.poolInfo.normalPools = match.poolInfo.normalPools?.filter(x => x != betType);
//                 match.poolInfo.inplayPools = match.poolInfo.inplayPools?.filter(x => x != betType);
//                 match.poolInfo.sellingPools = match.poolInfo.sellingPools?.filter(x => x != betType);
//             break;
//         case 'SellingStarted':
//             if(lines.filter(line => line.st=== 'Available' ).length == 0){
//                 match.poolInfo.normalPools = match.poolInfo.normalPools.filter(x => x != betType);
//                 match.poolInfo.inplayPools = match.poolInfo.inplayPools.filter(x => x != betType);
//                 match.poolInfo.sellingPools = match.poolInfo.sellingPools.filter(x => x != betType);
//             }else if(window.fbConfig.GSPools.includes(betType.slice(0,3)) && !lines[0]?.comb?.some(comb=> comb.st === 'Available')){
//                 match.poolInfo.normalPools = match.poolInfo.normalPools.filter(x => x != betType);
//                 match.poolInfo.inplayPools = match.poolInfo.inplayPools.filter(x => x != betType);
//                 match.poolInfo.sellingPools = match.poolInfo.sellingPools.filter(x => x != betType);
//             }else{
//                 match.poolInfo.normalPools.push(betType);
//                 match.poolInfo.normalPools = [...new Set(match.poolInfo.normalPools)];
//                 if ( inplay ) {
//                     match.poolInfo.inplayPools.push(betType);
//                     match.poolInfo.inplayPools = [...new Set(match.poolInfo.inplayPools)];
//                 }else{
//                     match.poolInfo.inplayPools = match.poolInfo.inplayPools.filter(btype => btype != betType )
//                 }
//                 match.poolInfo.sellingPools.push(betType);
//                 match.poolInfo.sellingPools = [...new Set(match.poolInfo.sellingPools)];
//                 if(match.poolInfo.definedPools){
//                     match.poolInfo.definedPools.push(betType);
//                     match.poolInfo.definedPools = [...new Set(match.poolInfo.definedPools)];
//                 }
//             }
//             break;
//         case 'SellingStopped':
//         case 'Hold':
//             if(lines.filter(line => line.st=== 'Available' ).length == 0){
//                 match.poolInfo.normalPools = match.poolInfo.normalPools?.filter(x => x != betType);
//                 match.poolInfo.inplayPools = match.poolInfo.inplayPools?.filter(x => x != betType);
//                 match.poolInfo.sellingPools = match.poolInfo.sellingPools?.filter(x => x != betType);
//             }else if(window.fbConfig.GSPools.includes(betType.slice(0,3)) && !lines[0]?.comb?.some(comb=> comb.st === 'Available')){
//                 match.poolInfo.normalPools = match.poolInfo.normalPools.filter(x => x != betType);
//                 match.poolInfo.inplayPools = match.poolInfo.inplayPools.filter(x => x != betType);
//                 match.poolInfo.sellingPools = match.poolInfo.sellingPools.filter(x => x != betType);
//             }else{
//                 match.poolInfo.normalPools?.push(betType);
//                 match.poolInfo.normalPools = [...new Set(match.poolInfo.normalPools)];
//                 if ( inplay ) {
//                     match.poolInfo.inplayPools.push(betType);
//                     match.poolInfo.inplayPools = [...new Set(match.poolInfo.inplayPools)];
//                 }else{
//                     match.poolInfo.inplayPools = match.poolInfo.inplayPools.filter(btype => btype != betType )
//                 }
//                 match.poolInfo.sellingPools = match.poolInfo.sellingPools.filter(x => x != betType);
//             }
//             break;
//     }

//     updateScoringInfo(match,pool, message);
// }

// const updateScoringInfo = (match, message) => {
//     if ( !["NTS", "ENT", 'AGS', 'NGS'].includes(message.bTyp) )
//         return;
//     let infoNameMap = {
//         NTS: "ntsInfo",
//         ENT: "entInfo",
//         NGS: 'ngsInfo',
//         AGS: 'agsInfo'
//     }
//     let infoName = infoNameMap[message.bTyp];
//     if(["NTS", "ENT"].includes(message.bTyp)){
//         match.poolInfo[infoName] = match.poolInfo[infoName].filter(x=> x.indexOf(message.instNo + ":") < 0);
//         if ( message.st.indexOf("Refund")>=0 ) {
//             match.poolInfo[infoName].push(message.instNo + ":RFD");
//         }
//         else if ( message.st.indexOf("PayoutStarted")>=0 ) {
//             let winComb = message.lines?.line?.[0]?.comb?.filter(x=> x.st.toUpperCase()==="WIN")[0];
//             if ( winComb ) {
//                 match.poolInfo[infoName].push(message.instNo + ":" + winComb.str);
//             }
//         }
//     }
//     else if(["NGS"].includes(message.bTyp)){
//         match.poolInfo[infoName] = match?.poolInfo?.[infoName]?.filter(x=> x.instNo != message.instNo) || [];
//         if ( message.st.indexOf("Refund")>=0 ) {
//             let ngsInfo = {
//                 instNo: message.instNo,
//                 str: 'RFD',
//                 name_en: '',
//                 name_ch: ''
//             }
//             match.poolInfo[infoName].push(ngsInfo);
//         }
//         else if ( message.st.indexOf("PayoutStarted")>=0 ) {
//             let winComb = message.lines?.line?.[0]?.comb?.filter(x=> x.st.toUpperCase()==="WIN")[0];
//             let sel = message.dtl.sel.find(i => winComb.id == i.id) || {}
//             let playerName = sel.ref?.ply?.[0]?.nm || sel.ref?.nm
//             console.debug(sel, playerName)
//             let name_ch = playerName?.filter(x => x.ln =="zh-hk")[0]?.val;
//             let name_en = playerName?.filter(x => x.ln =="en-us")[0]?.val;
//             if ( winComb ) {
//                 let ngsInfo = {
//                     instNo: message.instNo,
//                     str: sel.str,
//                     name_en,
//                     name_ch
//                 }
//                 match.poolInfo[infoName].push(ngsInfo);
//             }
//         }
//     }
//     else if(["AGS"].includes(message.bTyp)){
//         let agsWinCombs = message.lines?.line?.[0]?.comb?.filter(x=> x.st.toUpperCase()==="WIN")
//         let agsInfo = agsWinCombs.map(item => {
//             let sel = message.dtl.sel.find(i => item.str == i.str) || {}
//             let playerName = sel.ref?.ply?.[0]?.nm 
//             let name_ch = playerName?.filter(x => x.ln =="zh-hk")[0]?.val;
//             let name_en = playerName?.filter(x => x.ln =="en-us")[0]?.val;
//             return {str: item.str, name_en, name_ch}
//         })
//         match.poolInfo.agsInfo = agsInfo
//     }

// }

export const updatePoolOdds = (pool, message) =>{
    let newPool = JSON.parse(JSON.stringify(pool))
    newPool.lines.forEach((line, index)=>{
        let pushLine = message?.lines?.line?.find(item => item.id === line.lineId)
        if(!pushLine || !pushLine?.comb) return
        line.combinations = line.combinations.map(comb =>{
            let pushComb = pushLine.comb.find(c => c.id == comb.combId)
            let currentOdds = pushComb?.odds?.cur?.odds || comb.currentOdds
            return {
                ...comb,
                currentOdds
            }
        })
    })

    return newPool
}

//   const loadfoPoolStatus = (paras,callbackFunc) => {
//         Promise.all([Query({ 
//             query : getFoPools(),
//             variables: {
//                 fbOddsTypes: paras.betTypes,
//                 poolIds: paras.poolIds,
                
//             }
//         })])
//         .then(([results]) => {
//             callbackFunc(results);
//         }).catch(error => apiErrorCallback(error, ()=>{loadfoPoolStatus(callbackFunc)}));
//     }